var DownloadLogModule = (function () {
    function DownloadLogModule() {
    }
    return DownloadLogModule;
}());
export { DownloadLogModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/download-log/download-log.module.ts.pre-build-optimizer.js